import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { captureUtm } from "./lib/utm";
import { captureReferral } from "./lib/referral";

import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import Boxes from "./pages/Boxes";
import Partnerships from "./pages/Partnerships";
import Waitlist from "./pages/Waitlist";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function UtmCapture() {
  useEffect(() => { captureUtm(); captureReferral(); }, []);
  return null;
}

function WithLayout({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <UtmCapture />
      <Toaster position="top-center" toastOptions={{
        style: { background: "#1A1A1A", color: "#FFFFF0", border: "1px solid #D4AF37", borderRadius: 0 }
      }} />
      <Routes>
        <Route path="/" element={<WithLayout><Home /></WithLayout>} />
        <Route path="/about" element={<WithLayout><About /></WithLayout>} />
        <Route path="/how-it-works" element={<WithLayout><HowItWorks /></WithLayout>} />
        <Route path="/boxes" element={<WithLayout><Boxes /></WithLayout>} />
        <Route path="/partnerships" element={<WithLayout><Partnerships /></WithLayout>} />
        <Route path="/waitlist" element={<WithLayout><Waitlist /></WithLayout>} />
        <Route path="/faq" element={<WithLayout><FAQ /></WithLayout>} />
        <Route path="/contact" element={<WithLayout><Contact /></WithLayout>} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}
